module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsBAMAAADsqkcyAAAAMFBMVEUAAABVYf9UYP9TX/9VYf9UYP9TYf9UYP9UYP9UYP+1uv+2u/+3vP/8/f/9/f////8FD85MAAAACXRSTlMAVFVWV9TW/P3YNh/gAAAAVklEQVQoz2NgGMKAOXwmHJQawIUlZyKByXDhyLX/4eD2VLhw5X2E8N/pcOGZ/5HATKoLw5xHnDAtXTICfIkjipETxBtEgtBETj5T4MIs6QjRNoehnG0AijBK2gjE0zMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/course/cont@2x.png
// module id = NpVS
// module chunks = 0